import { render, staticRenderFns } from "./Step4ProductTable.vue?vue&type=template&id=6469eaa2&scoped=true"
import script from "./Step4ProductTable.vue?vue&type=script&lang=js"
export * from "./Step4ProductTable.vue?vue&type=script&lang=js"
import style0 from "./Step4ProductTable.vue?vue&type=style&index=0&id=6469eaa2&prod&lang=css"
import style1 from "./Step4ProductTable.vue?vue&type=style&index=1&id=6469eaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6469eaa2",
  null
  
)

export default component.exports